import React from "react";
import { Link } from "react-router-dom";

type CtaBandProps = {
  title: string;
  text: string;
  to: string;
  label: string;
};

function CtaBand({ title, text, to, label }: CtaBandProps) {
  return (
    <section className="cta-band">
      <div className="container cta-band-inner">
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
        <Link className="cta-button" to={to}>
          {label}
        </Link>
      </div>
    </section>
  );
}

export default CtaBand;
